export const SDK_NAME = 'sentry.javascript.cordova';
export const SDK_VERSION = '1.0.3-dev-2.1';
